import {StyleSheet} from 'react-native';

import {variants} from '/component/base/Text/Text.style';
import {
  cloudLight,
  cloudLighter,
  onyx,
  onyxLightest,
} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    paddingLeft: 8,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 22,
    height: '100%',
  },
  header: {
    marginBottom: 16,
    flexDirection: 'row',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingBottom: 14,
  },

  iconContainer: {
    marginRight: 8,
    alignSelf: 'center',
    cursor: 'pointer',
    height: 30,
    width: 30,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: cloudLighter,
  },
  closeIcon: {
    fontSize: 18,
    color: onyx,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginBottom: 16,
  },
  body: {
    marginTop: 6,
    marginLeft: 0,
  },
  bodyScroll: {
    width: '100%',
  },
  bodyContent: {
    paddingRight: 4,
  },
  sectionBlock: {
    marginBottom: 12,
  },
  popoverHeadingText: {
    ...variants.large,
    ...getFontFamily('bold'),
    color: onyx,
    fontSize: 16,
  },
  popoverTextTitle: {
    ...variants.small,
    ...getFontFamily('bold'),
    color: onyx,
    fontSize: 13,
  },
  popoverTextBody: {
    ...variants.small,
    ...getFontFamily('regular'),
    color: onyxLightest,
    maxWidth: 520,
    fontSize: 13,
  },
  sectionDescriptionWithTitle: {
    marginTop: 4,
  },
});
